/**
 * @architecture-header 1
 * @layer module
 * @domain live
 * @responsibility Own high-frequency live board selection, sort, and end-session mode.
 * @state-owner module-scoped Zustand
 * @allowed-imports Zustand; shared transient reset registry
 * @forbidden server entities; roles; permissions; tokens; realtime channels
 * @public-api live module only
 * @side-effects in-memory UI updates
 * @tests module-contracts.test.ts
 */

import { create } from 'zustand';
import { registerWorkspaceTransientReset } from '../../../shared/lib/transient-reset';

interface LiveUiState {
  selectedStudentId: string | null;
  sort: 'priority' | 'progress' | 'name';
  endMode: 'only' | 'follow';
  selectStudent(id: string | null): void;
  setSort(sort: LiveUiState['sort']): void;
  setEndMode(mode: LiveUiState['endMode']): void;
  reset(): void;
}

export const useLiveUiStore = create<LiveUiState>((set) => ({
  selectedStudentId: null,
  sort: 'priority',
  endMode: 'only',
  selectStudent: (selectedStudentId) => set({ selectedStudentId }),
  setSort: (sort) => set({ sort }),
  setEndMode: (endMode) => set({ endMode }),
  reset: () => set({ selectedStudentId: null, sort: 'priority', endMode: 'only' }),
}));

registerWorkspaceTransientReset('live-ui', () => useLiveUiStore.getState().reset());
